import {isClass} from "@cm/utils"
import {z} from "zod"

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null(), z.undefined()])
type Literal = z.infer<typeof literalSchema>
export type Json = Literal | {[key: string]: Json} | Json[]
export const jsonSchema: z.ZodType<Json> = z.custom<Json>((data) => {
    const seen = new WeakSet()

    function validate(val: unknown): boolean {
        if (val === null || typeof val !== "object") return literalSchema.safeParse(val).success

        if (Array.isArray(val)) return val.every((item) => validate(item))

        if (isClass(val)) return false

        if (seen.has(val)) return true

        seen.add(val)

        return Object.values(val).every((propVal) => validate(propVal))
    }

    return validate(data)
})
